import { useTranslation } from 'react-i18next'

import { PopUpDelete } from '@components/PopUpDelete'
import { useAuthStore } from '@libs/zustand/auth/auth.store'

import type { JSX } from 'react'

export const AccountSwitchConfirmation = (): JSX.Element | null => {
  const { t } = useTranslation()

  const pendingAccessToken = useAuthStore((s) => s.state.pendingAccessToken)
  const { switchAccount, dismissPendingAccessToken } = useAuthStore((s) => s.actions)

  if (!pendingAccessToken) return null

  return (
    <PopUpDelete
      type="validate"
      title={t('modules_auth_components_AccountSwitchConfirmation_title')}
      description={t('modules_auth_components_AccountSwitchConfirmation_description')}
      onSubmitLabel={t('modules_auth_components_AccountSwitchConfirmation_submit')}
      onSubmit={async () => {
        await switchAccount(pendingAccessToken)
        // Le rechargement vide les caches (Apollo, stores) remplis pour le compte précédent.
        window.location.reload()
      }}
      onClose={dismissPendingAccessToken}
    />
  )
}
